export default __webpack_public_path__ + "static/media/SZ10.ae64f3b6.mp3";